import React, { useState, useEffect, useRef } from "react";
import {
  ChevronLeft,
  ChevronRight,
  MapPin,
  Phone,
  Mail,
  Send,
  MessageCircle,
} from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { BLOG_POSTS } from "../../data/insightsData";


// Feature logos
import fElle from "../../asset/images/featurelogo/Elle.svg";
import fBridesToday from "../../asset/images/featurelogo/bridestoday.png";
import fCosmo from "../../asset/images/featurelogo/cosmo.png";
import fEsquire from "../../asset/images/featurelogo/esquire.png";
import fGrazia from "../../asset/images/featurelogo/grazia.png";
import fLifeStyle from "../../asset/images/featurelogo/lifestyle.png";
import fVogue from "../../asset/images/featurelogo/vogue.png";

// logos
import sr from "../../asset/images/Logos/10.png";
import abrakh from "../../asset/images/Logos/1.png";
import shashagabal from "../../asset/images/Logos/2.png";
import glypticarts from "../../asset/images/Logos/3.png";
import miku from "../../asset/images/Logos/4.png";
import sha from "../../asset/images/Logos/5.png";
import yapidra from "../../asset/images/Logos/6.png";
import oak from "../../asset/images/Logos/7.png";
import maharashtra from "../../asset/images/Logos/9.png";
import swati from "../../asset/images/Logos/11.png";
import jade from "../../asset/images/Logos/12.png";
import noor from "../../asset/images/Logos/13.png";
import kesari from "../../asset/images/Logos/14.png";
import sammohan from "../../asset/images/Logos/15.png";
import pentagon from "../../asset/images/Logos/16.png";
import adyaaye from "../../asset/images/Logos/64.png";
import gavins from "../../asset/images/Logos/65.png";
import anothe from "../../asset/images/Logos/17.png";
import bajaj from "../../asset/images/Logos/bajajfoundation.png";
import bling from "../../asset/images/Logos/bling.avif";
import designer from "../../asset/images/Logos/designerhype.png";
import herstories from "../../asset/images/Logos/herstorie.png";
import jigar from "../../asset/images/Logos/jigarNikita.png";
import sk from "../../asset/images/Logos/skjewellers.png";
import tero from "../../asset/images/Logos/Teronew.png";
import vintage from "../../asset/images/Logos/vintage.png";
import dollynagpal from "../../asset/images/Logos/Dollynagpal.png";
import logo8 from "../../asset/images/Logos/8.png";
import logo66 from "../../asset/images/Logos/66.png";
import abrakh2 from "../../asset/images/Logos/abrakh2.png";
import miku2 from "../../asset/images/Logos/miku.png";

// Recent works
import creative1 from "../../asset/images/andprWebsiteImages/creative1.jpg";
import creative2 from "../../asset/images/andprWebsiteImages/creative2.jpg";
import creative3 from "../../asset/images/andprWebsiteImages/creative3.jpg";
import AkshayxNOU from "../../asset/images/Celebrity/akshaykumar.png";
import latestwork1 from "../../asset/images/latestwork1.jpg";
import latestwork2 from "../../asset/images/latestwork2.jpg";
import latestwork3 from "../../asset/images/latestwork3.jpg";

import andprvideo from "../../asset/images/andprbannervideo.mp4";
import andprdesktopvideo from "../../asset/images/andprbannerdesktop.mp4";

import {
  footerData,
  faqData,
  pricingData,
  processSteps,
  submitContactForm,
  testimonials,
} from "../../data/mock.js";

/* ═══════════════════════════════════════════════════════════════════════════
   PALETTE  →  white (#ffffff) · black (#000000) · champagne (#F7E6CA)
═══════════════════════════════════════════════════════════════════════════ */
const GLOBAL_CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;1,300;1,400&family=Montserrat:wght@300;400;500;600&display=swap');

  *, *::before, *::after { box-sizing: border-box; }

  :root {
    --gold:       #F7E6CA;
    --black:      #000000;
    --white:      #ffffff;
    --border:     rgba(0,0,0,0.1);
    --border-inv: rgba(247,230,202,0.15);
    --font-display: 'Cormorant Garamond', Georgia, serif;
    --font-body:    'Montserrat', sans-serif;
  }

  html { scroll-behavior: smooth; }
  body { font-family: var(--font-body); background: var(--white); }

  /* ── Animations ── */
  @keyframes fadeUp {
    from { opacity: 0; transform: translateY(32px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes fadeIn {
    from { opacity: 0; }
    to   { opacity: 1; }
  }
  @keyframes scrollFloat {
    0%, 100% { transform: translateY(0); opacity: 1; }
    50%       { transform: translateY(10px); opacity: 0.8; }
  }
  @keyframes marquee {
    0%   { transform: translateX(0); }
    100% { transform: translateX(-50%); }
  }
  @keyframes marqueeReverse {
    0%   { transform: translateX(-50%); }
    100% { transform: translateX(0); }
  }
  @keyframes ping {
    0%   { transform: scale(1); opacity: 0.6; }
    80%  { transform: scale(2); opacity: 0; }
    100% { transform: scale(2); opacity: 0; }
  }

  /* ── Creative Banner ── */
  .lux-creative-banner {
    padding: 50px 20px;
    background: var(--white);
    max-width: 1400px;
    margin: 0 auto;
  }
  .lux-creative-banner-header {
    text-align: center;
    margin-bottom: 30px;
  }
  .lux-creative-grid {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 32px;
  }
  .lux-creative-img-wrap {
    position: relative;
    overflow: hidden;
    border-radius: 4px;
  }
  .lux-creative-img-wrap:nth-child(1) {
    width: 28%;
    transform: translateY(40px);
  }
  .lux-creative-img-wrap:nth-child(2) {
    width: 38%;
    z-index: 2;
    box-shadow: 0 20px 50px rgba(0,0,0,0.15);
  }
  .lux-creative-img-wrap:nth-child(3) {
    width: 28%;
    transform: translateY(-40px);
  }
  .lux-creative-img {
    width: 100%;
    height: auto;
    display: block;
    object-fit: cover;
    transition: transform 0.7s cubic-bezier(0.22, 1, 0.36, 1);
  }
  .lux-creative-img-wrap:hover .lux-creative-img {
    transform: scale(1);
  }

  @media (max-width: 1024px) {
    .lux-creative-grid {
      gap: 15px;
    }
  }
  
  @media (max-width: 768px) {
    .lux-creative-banner {
      padding: 30px 10px;
    }
    .lux-creative-grid {
      flex-direction: column;
      gap: 10px;
    }
    .lux-creative-img-wrap:nth-child(1),
    .lux-creative-img-wrap:nth-child(2),
    .lux-creative-img-wrap:nth-child(3) {
      width: 100%;
      transform: none;
    }
  }

  /* ── Reveal ── */
  .lux-reveal {
    opacity: 0;
    transform: translateY(24px);
    transition: opacity 0.9s cubic-bezier(0.22,1,0.36,1),
                transform 0.9s cubic-bezier(0.22,1,0.36,1);
  }
  .lux-reveal.visible { opacity: 1; transform: none; }
  .lux-reveal-d1 { transition-delay: 0.1s; }
  .lux-reveal-d2 { transition-delay: 0.22s; }
  .lux-reveal-d3 { transition-delay: 0.34s; }
  .lux-reveal-d4 { transition-delay: 0.46s; }

  /* ── Hero ── */
  .lux-hero {
    position: relative;
    width: 100%;
    height: 100dvh;
    min-height: 640px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .lux-hero-video {
    position: absolute;
    inset: 0;
    width: 100%; height: 100%;
    object-fit: cover;
    object-position: center;
    z-index: 0;
  }
  .lux-hero-overlay {
    position: absolute;
    inset: 0;
    z-index: 1;
    background: linear-gradient(
      to bottom,
      rgba(0,0,0,0.75) 0%,
      rgba(0,0,0,0.40) 45%,
      rgba(0,0,0,0.40) 60%,
      rgba(0,0,0,0.78) 100%
    );
  }
  .lux-hero-grain {
    position: absolute;
    inset: 0;
    z-index: 2;
    opacity: 0.025;
    background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E");
    background-repeat: repeat;
    pointer-events: none;
  }
  .lux-hero-content {
    position: relative;
    z-index: 3;
    text-align: center;
    padding: 0 32px;
    max-width: 920px;
    width: 100%;
    margin-top: 14vh;
  }
  .lux-eyebrow {
    display: inline-flex;
    align-items: center;
    gap: 16px;
    color: var(--gold);
    font-family: var(--font-body);
    font-size: 10px;
    letter-spacing: 0.35em;
    text-transform: uppercase;
    font-weight: 500;
    margin-bottom: 32px;
    animation: fadeIn 1s ease 0.3s both;
  }
  .lux-eyebrow::before,
  .lux-eyebrow::after {
    content: '';
    display: block;
    width: 48px;
    height: 0.5px;
    background: var(--gold);
    opacity: 0.7;
  }
  .lux-hero-headline {
    font-family: var(--font-display);
    font-size: clamp(44px, 8vw, 98px);
    font-weight: 300;
    line-height: 1.0;
    color: var(--white);
    letter-spacing: -1px;
    margin: 0 0 40px;
    animation: fadeUp 1.1s cubic-bezier(0.22,1,0.36,1) 0.45s both;
  }
  .lux-hero-headline em {
    font-style: italic;
    color: var(--gold);
  }
  .lux-hero-tagline {
    font-family: var(--font-body);
    font-size: clamp(14px, 1.5vw, 16px);
    font-weight: 300;
    line-height: 1.4;
    color: rgba(255,255,255,0.88);
    max-width: 580px;
    margin: 0 auto;
    letter-spacing: 0.02em;
    animation: fadeUp 1s cubic-bezier(0.22,1,0.36,1) 0.7s both;
  }

  /* CTA — champagne bg, black text */
  .lux-hero-cta {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    background: var(--gold);
    color: var(--black);
    padding: 16px 40px;
    font-family: var(--font-body);
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    text-decoration: none;
    margin-top: 40px;
    transition: background 0.3s, transform 0.3s;
  }
  .lux-hero-cta:hover {
    background: var(--white);
    transform: translateY(-2px);
  }

  /* Ghost btn — white border, hover champagne */
  .lux-btn-ghost {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    background: transparent;
    color: var(--black);
    border: 0.5px solid rgba(0,0,0,0.35);
    padding: 15px 40px;
    font-family: var(--font-body);
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 0.25em;
    text-transform: uppercase;
    cursor: pointer;
    text-decoration: none;
    transition: border-color 0.3s, color 0.3s, background 0.3s, transform 0.2s;
  }
  .lux-btn-ghost:hover {
    border-color: var(--black);
    background: var(--black);
    color: var(--gold);
    transform: translateY(-1px);
  }

  /* Section tag */
  .lux-section-tag {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    font-family: var(--font-body);
    font-size: 9px;
    letter-spacing: 0.3em;
    font-weight: 600;
    color: var(--black);
    text-transform: uppercase;
  }
  .lux-section-tag::before {
    content: '';
    display: block;
    width: 32px;
    height: 0.5px;
    background: var(--black);
  }

  /* ── Featured In — white bg ── */
  .lux-featured {
    background: var(--white);
    padding: 60px 0;
    border-top: 0.5px solid var(--border);
    border-bottom: 0.5px solid var(--border);
  }
  .lux-featured-inner {
    max-width: 1320px;
    margin: 0 auto;
    padding: 0 48px;
    text-align: center;
  }
  .lux-featured-label {
    font-family: var(--font-body);
    font-size: 16px;
    letter-spacing: 0.25em;
    text-transform: uppercase;
    color: var(--black);
    opacity: 0.8;
    font-weight: 400;
    margin-bottom: 32px;
  }
  .lux-featured-marquee-container {
    width: 100%;
    overflow: hidden;
    position: relative;
    padding: 10px 0;
  }
  .lux-featured-marquee-container::before,
  .lux-featured-marquee-container::after {
    content: '';
    position: absolute;
    top: 0;
    width: 100px;
    height: 100%;
    z-index: 2;
    pointer-events: none;
  }
  .lux-featured-marquee-container::before {
    left: 0;
    background: linear-gradient(to right, var(--white) 0%, transparent 100%);
  }
  .lux-featured-marquee-container::after {
    right: 0;
    background: linear-gradient(to left, var(--white) 0%, transparent 100%);
  }
  .lux-featured-marquee {
    display: flex;
    width: max-content;
    animation: marquee 35s linear infinite;
    align-items: center;
  }

  .lux-featured-logo-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 72px;
  height: 80px;
  flex-shrink: 0;
}
.lux-featured-logo-item img {
  height: 90px;
  width: 120px;
  object-fit: contain;
  filter: grayscale(100%) brightness(1);
}

  /* ── About — white bg ── */
  .lux-about {
    background: var(--white);
    padding: 120px 0 0;
  }
  .lux-about-inner {
    max-width: 1320px;
    margin: 0 auto;
    padding: 0 48px 100px;
    display: grid;
    grid-template-columns: 1fr 1.6fr;
    gap: 80px;
    align-items: start;
  }
  .lux-about-title {
    font-family: var(--font-display);
    font-size: 72px;
    font-weight: 300;
    line-height: 1.0;
    color: var(--black);
    letter-spacing: -1px;
    margin: 24px 0 0;
  }
  .lux-about-title em { font-style: italic; color: var(--black); opacity: 0.35; }
  .lux-about-desc {
    font-family: var(--font-body);
    font-size: 16px;
    font-weight: 300;
    line-height: 1.85;
    color: var(--black);
    margin: 0 0 40px;
    max-width: 480px;
  }
  .lux-read-btn {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    font-family: var(--font-body);
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.25em;
    text-transform: uppercase;
    color: var(--black);
    text-decoration: none;
    border-bottom: 0.5px solid var(--black);
    padding-bottom: 4px;
    transition: color 0.2s, border-color 0.2s, opacity 0.2s;
  }
  .lux-read-btn:hover { opacity: 0.55; }
  .lux-read-btn svg { transition: transform 0.2s; }
  .lux-read-btn:hover svg { transform: translateX(4px); }

  /* Logo marquee strip — white bg */
  .lux-logos-strip {
    border-top: 0.5px solid var(--border);
    padding: 20px 0;
    overflow: hidden;
    background: var(--white);
  }
  .lux-marquee-row {
    display: flex;
    gap: 0;
    width: max-content;
  }
  .lux-marquee-row.fwd  { animation: marquee 40s linear infinite; }
  .lux-marquee-row.rev  { animation: marqueeReverse 32s linear infinite; }
  .lux-logo-pill {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 48px;
    height: 80px;
    border-right: 0.5px solid var(--border);
    white-space: nowrap;
    transition: opacity 0.3s;
    opacity: 0.5;
    filter: grayscale(100%);
  }
  .lux-logo-pill:hover { opacity: 0.5; filter: none; }

  /* ── Work — white bg ── */
  .lux-work {
    background: var(--white);
    padding: 60px 0;
    border-top: 0.5px solid var(--border);
  }
  .lux-work-inner {
    max-width: 1320px;
    margin: 0 auto;
    padding: 0 48px;
  }
  .lux-work-header {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-bottom: 64px;
  }
  .lux-work-title {
    font-family: var(--font-display);
    font-size: 64px;
    font-weight: 300;
    color: var(--black);
    letter-spacing: -1px;
    line-height: 1.0;
    margin-top: 20px;
  }
  .lux-work-title em { font-style: italic; opacity: 0.35; }
  .lux-work-grid {
    column-count: 2;
    column-gap: 4px;
  }
  .lux-work-card {
    position: relative;
    overflow: hidden;
    cursor: pointer;
    background: #f0f0f0;
    break-inside: avoid;
    margin-bottom: 4px;
    display: block;
    width: 100%;
  }
  .lux-work-card img {
    width: 100%;
    height: auto;
    display: block;
    transition: transform 0.8s cubic-bezier(0.22,1,0.36,1), filter 0.5s ease;
    filter: brightness(0.9) saturate(0.85);
  }
  .lux-work-card:hover img { transform: scale(1.06); filter: brightness(0.6) saturate(0); }
  .lux-work-card-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(to top, rgba(0,0,0,0.85) 0%, transparent 55%);
    opacity: 0;
    transition: opacity 0.4s ease;
    display: flex;
    align-items: flex-end;
    padding: 32px;
  }
  .lux-work-card:hover .lux-work-card-overlay { opacity: 1; }
  .lux-work-card-info h3 {
    font-family: var(--font-display);
    font-size: 24px;
    font-weight: 300;
    color: var(--white);
    letter-spacing: -0.3px;
    margin: 0 0 4px;
  }
  .lux-work-card-info p {
    font-family: var(--font-body);
    font-size: 9px;
    letter-spacing: 0.25em;
    text-transform: uppercase;
    color: var(--gold);
    margin: 0;
  }
  .lux-work-footer {
    display: flex;
    justify-content: center;
    margin-top: 64px;
    border-top: 0.5px solid var(--border);
    padding-top: 64px;
  }

  /* ── Services — champagne bg ── */
  .lux-services {
    background: var(--white);
    padding: 120px 0;
  }
  .lux-services-inner {
    max-width: 1320px;
    margin: 0 auto;
    padding: 0 48px;
  }
  .lux-services-header {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 80px;
    align-items: end;
    margin-bottom: 80px;
  }
  .lux-services-title {
    font-family: var(--font-display);
    font-size: 60px;
    font-weight: 300;
    color: var(--black);
    letter-spacing: -1px;
    line-height: 1.05;
    margin-top: 20px;
  }
  .lux-services-title em { font-style: italic; opacity: 0.45; }
  .lux-services-subtitle {
    font-family: var(--font-body);
    font-size: 15px;
    font-weight: 300;
    line-height: 1.8;
    color: var(--black);

  }

  /* ── Insights ── */
.lux-insights {
  background: var(--white);
  padding: 60px 0;
  border-top: 0.5px solid var(--border);
}
.lux-insights-inner {
  max-width: 1320px;
  margin: 0 auto;
  padding: 0 48px;
}
.lux-insights-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 26px;
}
.lux-insights-title {
  font-family: var(--font-display);
  font-size: 60px;
  font-weight: 300;
  color: var(--black);
  letter-spacing: -1px;
  line-height: 1.0;
  margin-top: 16px;
}
.lux-insights-title em { font-style: italic; opacity: 0.35; }
.lux-insights-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1px;
  background: rgba(0,0,0,0.08);
}
.lux-insight-card {
  background: var(--white);
  padding: 36px 32px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  text-decoration: none;
  color: inherit;
  transition: background 0.25s;
}
.lux-insight-card:hover { background: #fafaf9; }
.lux-insight-cat {
  font-family: var(--font-body);
  font-size: 8px;
  letter-spacing: 0.25em;
  text-transform: uppercase;
  font-weight: 600;
  color: var(--black);
  opacity: 0.85;
}
.lux-insight-img-placeholder {
  width: 100%;
  height: 200px;
  background: #f0ede8;
  flex-shrink: 0;
}
.lux-insight-title {
  font-family: var(--font-display);
  font-size: 22px;
  font-weight: 300;
  color: var(--black);
  letter-spacing: -0.3px;
  line-height: 1.25;
}
.lux-insight-excerpt {
   font-family: var(--font-body);
    font-size: 12px;
    font-weight: 300;
    line-height: 1.75;
    color: #555555;
}
.lux-insight-meta {
  display: flex;
  align-items: center;
  margin-top: auto;
  padding-top: 16px;
  border-top: 0.5px solid rgba(0,0,0,0.08);
}
.lux-insight-date {
    font-family: var(--font-body);
    font-size: 9px;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    color: #777777;
    font-weight: 500;
}
.lux-insight-read {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: var(--font-body);
  font-size: 9px;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  color: var(--black);
  font-weight: 600;
}
.lux-insight-card:hover .lux-insight-read { opacity: 0.55; }
.lux-insights-footer {
  display: flex;
  justify-content: center;
  margin-top: 56px;
  padding-top: 56px;
  border-top: 0.5px solid var(--border);
}
  /* Section tag on champagne bg — use black */
  .lux-services .lux-section-tag {
    color: var(--black);
  }
  .lux-services .lux-section-tag::before {
    background: var(--black);
  }
  .lux-services-list {
    display: flex;
    flex-direction: column;
    border-top: 0.5px solid rgba(0,0,0,0.15);
  }
  .lux-service-row {
    display: grid;
    grid-template-columns: 64px 1fr auto;
    align-items: center;
    gap: 32px;
    padding: 28px 0;
    border-bottom: 0.5px solid rgba(0,0,0,0.1);
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: background 0.25s;
  }
  .lux-service-row::before {
    content: '';
    position: absolute;
    left: 0; top: 0;
    width: 0; height: 100%;
    background: rgba(0,0,0,0.06);
    transition: width 0.4s ease;
  }
  .lux-service-row:hover::before { width: 100%; }
  .lux-service-num {
    font-family: var(--font-display);
    font-size: 18px;
    font-weight: 400;
    color: var(--black);
    opacity: 0.35;
    letter-spacing: 0.05em;
  }
  .lux-service-name {
    font-family: var(--font-display);
    font-size: 26px;
    font-weight: 300;
    color: var(--black);
    letter-spacing: -0.3px;
  }
  .lux-service-main { flex: 1; }
  .lux-service-details {
    margin-top: 6px;
    transition: opacity 0.2s ease, transform 0.2s ease;
  }
  .lux-service-row:not(.is-open) .lux-service-details {
    opacity: 0;
    transform: translateY(-4px);
    pointer-events: none;
  }
  .lux-service-desc {
    font-family: var(--font-body);
    font-size: 13px;
    font-weight: 300;
    color: var(--black);
    line-height: 1.6;
    max-width: 360px;
  }
  .lux-service-points {
    margin-top: 6px;
    padding-left: 18px;
    font-size: 13px;
    line-height: 1.5;
    color: var(--black);
   
  }
  .lux-service-points li + li { margin-top: 4px; }
  .lux-service-arrow {
    width: 40px; height: 40px;
    border: 0.5px solid rgba(0,0,0,0.25);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: border-color 0.2s, background 0.2s, transform 0.2s;
    flex-shrink: 0;
  }
  .lux-service-row:hover .lux-service-arrow {
    border-color: var(--black);
    background: var(--black);
    transform: rotate(45deg);
  }
  .lux-service-row:hover .lux-service-arrow svg { color: var(--gold); }

  /* ── Testimonials — black bg ── */
  .lux-testimonials {
    background: var(--white);
    padding: 60px 0;
  }
  .lux-testimonials-inner {
    max-width: 1320px;
    margin: 0 auto;
    padding: 0 48px;
  }
  .lux-testimonials-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 80px;
  }
  .lux-testimonials-title {
    font-family: var(--font-display);
    font-size: 60px;
    font-weight: 300;
    color: var(--black);
    letter-spacing: -1px;
    line-height: 1.0;
    margin-top: 20px;
  }
  .lux-testimonials-title em { font-style: italic; color: var(--gold); }
  /* Section tag on black bg */
  .lux-testimonials .lux-section-tag {
    color: var(--black);
  }
  .lux-testimonials .lux-section-tag::before {
    background: var(--gold);
  }
  .lux-testi-nav { display: flex; gap: 8px; }
  .lux-nav-btn {
    width: 48px; height: 48px;
    border: 0.5px solid rgba(0,0,0,0.2);
    background: transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--black);
    transition: border-color 0.2s, background 0.2s, color 0.2s;
  }
  .lux-nav-btn:hover { border-color: var(--gold); background: var(--gold); color: var(--black); }
  .lux-testi-quote {
    font-family: var(--font-display);
    font-size: clamp(16px, 3vw, 22px);
    font-weight: 300;
    line-height: 1.6;
    color: var(--black);
    letter-spacing: -0.3px;
    max-width: 820px;
    margin-bottom: 48px;
    position: relative;
    padding-left: 40px;
  }
  .lux-testi-quote::before {
    content: '\u201C';
    position: absolute;
    left: 0; top: -8px;
    font-family: var(--font-display);
    font-size: 80px;
    font-weight: 300;
    color: var(--black);
    line-height: 1;
  }
  .lux-testi-author {
    display: flex;
    align-items: center;
    gap: 20px;
    padding-left: 40px;
  }
  .lux-testi-name {
    font-family: var(--font-display);
    font-size: 18px;
    font-weight: 400;
    color: var(--black);
  }
  .lux-testi-role {
    font-family: var(--font-body);
    font-size: 10px;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: #555555;
    font-weight: 500;
    margin-top: 2px;
  }
  .lux-testi-progress {
    display: flex;
    gap: 4px;
    margin-top: 60px;
    padding-left: 40px;
  }
  .lux-testi-dot {
     width: 32px; height: 1px;
    background: rgba(0,0,0,0.15);
    transition: background 0.3s, width 0.3s;
    cursor: pointer;
    border: none;
  }
  .lux-testi-dot.active { background: var(--gold); width: 56px; }

  /* ── Contact — white bg ── */
  .lux-contact {
    background: var(--white);
    padding: 60px 0;
    border-top: 0.5px solid var(--border);
  }
  .lux-contact-inner {
    max-width: 1320px;
    margin: 0 auto;
    padding: 0 48px;
  }
  .lux-contact-header { margin-bottom: 80px; }
  .lux-contact-title {
    font-family: var(--font-display);
    font-size: clamp(48px, 6vw, 88px);
    font-weight: 300;
    color: var(--black);
    letter-spacing: -2px;
    line-height: 1.0;
    margin-top: 20px;
  }
  .lux-contact-title em { font-style: italic; color: var(--black); opacity: 0.35; }
  .lux-contact-grid {
    display: grid;
    grid-template-columns: 1fr 1.4fr;
    gap: 80px;
  }
  .lux-contact-info-item {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    padding: 28px 0;
    border-bottom: 0.5px solid var(--border);
  }
  .lux-contact-icon {
    width: 40px; height: 40px;
    border: 0.5px solid var(--border);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    background: var(--gold);
  }
  .lux-contact-label {
    font-family: var(--font-body);
    font-size: 8px;
    letter-spacing: 0.25em;
    text-transform: uppercase;
    color: var(--black);
   
    font-weight: 600;
    margin-bottom: 6px;
  }
  .lux-contact-val {
    font-family: var(--font-display);
    font-size: 16px;
    font-weight: 400;
    color: var(--black);
    line-height: 1.5;
  }
  .lux-contact-val a {
    color: inherit;
    text-decoration: none;
    transition: opacity 0.2s;
  }
  .lux-contact-val a:hover { opacity: 0.55; }
  .lux-form-field { margin-bottom: 24px; }
  .lux-form-label {
    display: block;
    font-family: var(--font-body);
    font-size: 8px;
    letter-spacing: 0.25em;
    text-transform: uppercase;
    color: var(--black);
    font-weight: 600;
    margin-bottom: 10px;
  }
  .lux-form-input {
    width: 100%;
    background: transparent;
    border: none;
    border-bottom: 0.5px solid rgba(0,0,0,0.2);
    color: var(--black);
    font-family: var(--font-body);
    font-size: 15px;
    font-weight: 300;
    padding: 12px 0;
    outline: none;
    transition: border-color 0.2s;
    border-radius: 0;
  }
  .lux-form-input::placeholder { color: rgba(0,0,0,0.45); }
  .lux-form-input:focus { border-bottom-color: var(--black); }
  .lux-form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
  }
  /* Submit — champagne bg, black text */
  .lux-submit-btn {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    background: var(--black);
    color: var(--white);
    border: none;
    padding: 16px 48px;
    font-family: var(--font-body);
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.25em;
    text-transform: uppercase;
    cursor: pointer;
    margin-top: 16px;
    transition: background 0.25s, transform 0.2s;
    width: 100%;
    justify-content: center;
  }
  .lux-submit-btn:hover:not(:disabled) { background: var(--black); color: var(--gold); transform: translateY(-1px); }
  .lux-submit-btn:disabled { opacity: 0.5; cursor: not-allowed; }

  /* Success */
  .lux-success {
    padding: 16px 20px;
    border: 0.5px solid var(--border);
    background: rgba(247,230,202,0.25);
    margin-bottom: 28px;
    font-family: var(--font-body);
    font-size: 13px;
    color: var(--black);
    letter-spacing: 0.04em;
  }

  /* WhatsApp CTA */
  .lux-whatsapp-cta {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 40px;
    padding: 20px 24px;
    border: 0.5px solid var(--border);
    cursor: pointer;
    background: var(--white);
    width: 100%;
    transition: border-color 0.2s, background 0.2s;
    font-family: var(--font-body);
    font-size: 10px;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: var(--black);
    font-weight: 500;
  }
  .lux-whatsapp-cta:hover { border-color: var(--black); background: var(--gold); opacity: 1; }

  /* ── About stat numbers ── */
  .lux-stat-num {
    font-family: var(--font-display);
    font-size: 40px;
    color: var(--black);
    line-height: 1;
    font-weight: 400;
  }
  .lux-stat-lbl {
    font-family: var(--font-body);
    font-size: 11px;
    color: var(--black);

    line-height: 1.6;
    text-transform: uppercase;
    letter-spacing: 0.08em;
  }

  /* ── How We Work — white bg ── */
  .lux-process {
    background: var(--white);
    padding: 60px 0;
    border-bottom: 0.5px solid var(--border);
  }
  .lux-process-inner {
    max-width: 1320px;
    margin: 0 auto;
    padding: 0 48px;
  }
  .lux-process-header {
    display: grid;
    grid-template-columns: 1fr 1.5fr;
    gap: 80px;
    margin-bottom: 80px;
    align-items: end;
  }
  .lux-process-title {
    font-family: var(--font-display);
    font-size: clamp(48px, 6vw, 72px);
    font-weight: 300;
    color: var(--black);
    letter-spacing: -1px;
    line-height: 1.0;
    margin-top: 20px;
  }
  .lux-process-title em { font-style: italic; opacity: 0.45; }
  .lux-process-subtitle {
    font-family: var(--font-body);
    font-size: 15px;
    font-weight: 300;
    line-height: 1.8;
    color: var(--black);
 
  }
  .lux-process-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    border-top: 0.5px solid var(--border);
    border-left: 0.5px solid var(--border);
  }
  .lux-process-step {
    padding: 48px 32px;
    border-right: 0.5px solid var(--border);
    border-bottom: 0.5px solid var(--border);
    position: relative;
    transition: background 0.3s;
  }
  .lux-process-step:hover {
    background: rgba(0,0,0,0.02);
  }
  .lux-process-num {
    font-family: var(--font-display);
    font-size: 16px;
    color: var(--black);

    margin-bottom: 40px;
    letter-spacing: 0.05em;
  }
  .lux-process-name {
    font-family: var(--font-display);
    font-size: 26px;
    font-weight: 300;
    color: var(--black);
    margin-bottom: 16px;
    letter-spacing: -0.3px;
  }
  .lux-process-desc {
    font-family: var(--font-body);
    font-size: 13px;
    line-height: 1.7;
    color: var(--black);

    font-weight: 300;
  }
    /* ── Celebrities ── */
  .lux-celebs {
    background: var(--white);
    padding: 80px 0;
    border-top: 0.5px solid var(--border);
    overflow: hidden;
  }
  .lux-celebs-inner {
    max-width: 1320px;
    margin: 0 auto;
    padding: 0 48px;
  }
  .lux-celebs-header {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-bottom: 48px;
  }
  .lux-celebs-title {
    font-family: var(--font-display);
    font-size: 60px;
    font-weight: 300;
    color: var(--black);
    letter-spacing: -1px;
    line-height: 1.0;
    margin-top: 16px;
  }
  .lux-celebs-title em { font-style: italic; opacity: 0.35; }
  .lux-celebs-nav { display: flex; gap: 8px; }
  .lux-celebs-nav-btn {
    width: 44px; height: 44px;
    border: 0.5px solid rgba(0,0,0,0.2);
    background: transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--black);
    transition: border-color 0.2s, background 0.2s, color 0.2s;
    flex-shrink: 0;
  }
  .lux-celebs-nav-btn:hover {
    border-color: var(--black);
    background: var(--black);
    color: var(--gold);
  }
  @media (max-width: 768px) {
    .lux-celebs-nav-btn {
      width: 52px; height: 52px; /* larger touch target */
    }
  }
  .lux-celebs-track-wrapper {
    overflow: hidden;
    width: 100%;
  }
  .lux-celebs-track {
    display: flex;
    gap: 16px;
    transition: transform 0.55s cubic-bezier(0.22,1,0.36,1);
    will-change: transform;
  }
  .lux-celeb-card {
    flex-shrink: 0;
    width: calc((100% - 48px) / 4);
    position: relative;
    overflow: hidden;
    cursor: pointer;
    background: #f0ede8;
  }
  .lux-celeb-card img {
    width: 100%;
    aspect-ratio: 3 / 4;
    object-fit: cover;
    object-position: top center;
    display: block;
  }
  .lux-celeb-card-overlay {
    display: none;
  }
  .lux-celeb-info-name {
    font-family: var(--font-display);
    font-size: 20px;
    font-weight: 300;
    color: var(--white);
    letter-spacing: -0.2px;
    line-height: 1.2;
    margin: 0 0 4px;
  }
  .lux-celeb-info-tag {
    font-family: var(--font-body);
    font-size: 8px;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: var(--gold);
    font-weight: 600;
    margin: 0;
  }
  /* always-visible name strip at bottom */
  .lux-celeb-name-strip {
    padding: 14px 20px 16px;
    border-top: 0.5px solid var(--border);
    background: var(--white);
  }
  .lux-celeb-strip-name {
    font-family: var(--font-display);
    font-size: 17px;
    font-weight: 300;
    color: var(--black);
    letter-spacing: -0.2px;
    margin: 0 0 2px;
  }
  .lux-celeb-strip-tag {
    font-family: var(--font-body);
    font-size: 8px;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: #777777;
    font-weight: 500;
  }
  /* progress dots */
  .lux-celebs-dots {
    display: flex;
    gap: 4px;
    margin-top: 40px;
    justify-content: center;
  }
  .lux-celebs-dot {
    width: 28px; height: 1px;
    background: rgba(0,0,0,0.15);
    border: none;
    cursor: pointer;
    transition: background 0.3s, width 0.3s;
    padding: 0;
  }
  .lux-celebs-dot.active { background: var(--black); width: 52px; }
  @media (max-width: 768px) {
    .lux-celebs-dot {
      height: 3px; /* thicker line for easier visibility/tap */
      width: 32px;
    }
    .lux-celebs-dot.active { width: 60px; }
    .lux-celebs-dots { gap: 8px; margin-top: 32px; }
  }

  /* mobile responsive for celebs */
  @media (max-width: 1024px) {
    .lux-celeb-card { width: calc((100% - 32px) / 3); }
  }
  @media (max-width: 768px) {
    .lux-celebs { padding: 48px 0; }
    .lux-celebs-inner { padding: 0 20px; }
    .lux-celebs-header { flex-direction: column; align-items: flex-start; gap: 16px; margin-bottom: 28px; }
    .lux-celebs-title { font-size: 38px; margin-top: 10px; }
    .lux-celebs-nav { align-self: flex-end; }
    .lux-celeb-card { width: calc((100% - 12px) / 2); }
    .lux-celebs-track { gap: 12px; }
  }
  @media (max-width: 480px) {
    .lux-celebs { padding: 40px 0; }
    .lux-celebs-title { font-size: 30px; letter-spacing: -0.5px; }
    .lux-celeb-card { width: 85%; } /* peek effect */
    .lux-celebs-track { gap: 12px; }
    .lux-celeb-info-name { font-size: 18px; }
    .lux-celeb-strip-name { font-size: 15px; }
    .lux-celeb-name-strip { padding: 12px 16px; }
  }
  @media (max-width: 360px) {
    .lux-celebs-title { font-size: 26px; }
    .lux-celeb-card { width: 88%; }
    .lux-celeb-strip-name { font-size: 14px; }
  }

  /* Responsive */
  /* ── Mobile Base ── */
  @media (max-width: 1024px) {
    .lux-about-inner { grid-template-columns: 1fr; gap: 40px; padding: 0 32px 80px; }
    .lux-services-header { grid-template-columns: 1fr; gap: 24px; }
    .lux-work-header { flex-direction: column; align-items: flex-start; gap: 24px; }
    .lux-work-grid { column-count: 1; }
    .lux-testimonials-header { flex-direction: column; align-items: flex-start; gap: 24px; }
    .lux-contact-grid { grid-template-columns: 1fr; gap: 48px; }
    .lux-process-header { grid-template-columns: 1fr; gap: 24px; }
    .lux-process-grid { grid-template-columns: repeat(2, 1fr); }
  }

  @media (max-width: 768px) {
    /* ── Insights mobile ── */
    .lux-insights { padding: 48px 0; }
    .lux-insights-inner { padding: 0 20px; }
    .lux-insights-header {
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
      margin-bottom: 24px;
    }
    .lux-insights-title { font-size: 40px; margin-top: 10px; }
    .lux-insights-header .lux-btn-ghost {
      margin-bottom: 0 !important;
      width: 100%;
      justify-content: center;
      padding: 13px 24px;
    }
    .lux-insights-grid {
      grid-template-columns: 1fr;
      gap: 1px;
    }
    .lux-insight-card { padding: 28px 20px; gap: 12px; }
    .lux-insight-img-placeholder { height: 180px; }
    .lux-insight-title { font-size: 20px; }
    .lux-insight-excerpt { font-size: 13px; }

    /* ── Process mobile ── */
    .lux-process { padding: 48px 0; }
    .lux-process-inner { padding: 0 20px; }
    .lux-process-header {
      grid-template-columns: 1fr;
      gap: 16px;
      margin-bottom: 40px;
    }
    .lux-process-title { font-size: 40px; margin-top: 10px; }
    .lux-process-subtitle { font-size: 14px; }
    .lux-process-grid { grid-template-columns: 1fr; }
    .lux-process-step { padding: 32px 20px; }
    .lux-process-num { margin-bottom: 20px; }
    .lux-process-name { font-size: 22px; }

    /* ── Featured In mobile ── */
    .lux-featured { padding: 40px 0; }
    .lux-featured-inner { padding: 0 20px; }
    .lux-featured-label { font-size: 10px; letter-spacing: 0.2em; margin-bottom: 24px; }
    .lux-featured-logo-item {
      padding: 0 40px;
      height: 60px;
    }
    .lux-featured-logo-item img {
      height: 82px;
      width: 180px; 
    }

    /* ── Hero mobile ── */
    .lux-hero-content { padding: 0 20px; margin-top: 8vh; }
    .lux-hero-headline { font-size: clamp(38px, 10vw, 56px); margin: 0 0 24px; }
    .lux-hero-tagline { font-size: 13px; }
    .lux-hero-cta { padding: 14px 28px; font-size: 10px; margin-top: 28px; }

    /* ── Testimonials mobile ── */
    .lux-testimonials { padding: 48px 0; }
    .lux-testimonials-inner { padding: 0 20px; }
    .lux-testimonials-header {
      flex-direction: column;
      align-items: flex-start;
      gap: 20px;
      margin-bottom: 40px;
    }
    .lux-testimonials-title { font-size: 40px; margin-top: 10px; }
    .lux-testi-quote {
      font-size: 17px;
      padding-left: 28px;
      margin-bottom: 32px;
    }
    .lux-testi-quote::before { font-size: 56px; top: -4px; left: 0; }
    .lux-testi-author { padding-left: 28px; }
    .lux-testi-name { font-size: 16px; }
    .lux-testi-role { font-size: 9px; }
    .lux-testi-progress { padding-left: 28px; margin-top: 40px; }

    /* ── Contact mobile ── */
    .lux-contact { padding: 48px 0; }
    .lux-contact-inner { padding: 0 20px; }
    .lux-contact-header { margin-bottom: 40px; }
    .lux-contact-title { font-size: clamp(36px, 9vw, 56px); letter-spacing: -1px; }
    .lux-contact-grid { grid-template-columns: 1fr; gap: 36px; }
    .lux-contact-info-item { padding: 20px 0; }
    .lux-contact-val { font-size: 15px; }
    .lux-form-row { grid-template-columns: 1fr; gap: 0; }
    .lux-submit-btn { padding: 16px 24px; }
    .lux-whatsapp-cta { padding: 16px 20px; font-size: 9px; }

    /* ── Work mobile ── */
    .lux-work { padding: 48px 0; }
    .lux-work-inner { padding: 0 20px; }
    .lux-work-header {
      flex-direction: column;
      align-items: flex-start;
      gap: 20px;
      margin-bottom: 32px;
    }
    .lux-work-title { font-size: 40px; margin-top: 10px; }
    .lux-work-grid { column-count: 1; }
    .lux-work-header .lux-btn-ghost { width: 100%; justify-content: center; }

    /* ── About mobile ── */
    .lux-about { padding: 48px 0 0; }
    .lux-about-inner { grid-template-columns: 1fr; gap: 32px; padding: 0 20px 48px; }
    .lux-about-title { font-size: 40px; }
    .lux-about-desc { font-size: 14px; }
    .lux-stat-num { font-size: 32px; }
    .lux-stat-lbl { font-size: 10px; }
    .lux-logos-strip { padding: 12px 0; }
    .lux-logo-pill { padding: 0 28px; height: 60px; }

    /* ── Section tags mobile ── */
    .lux-section-tag { font-size: 8px; letter-spacing: 0.25em; }

    /* ── Ghost btn mobile ── */
    .lux-btn-ghost { font-size: 9px; padding: 13px 24px; letter-spacing: 0.2em; }
  }

  @media (max-width: 480px) {
    /* ── Insights extra small ── */
    .lux-insights-title { font-size: 34px; }
    .lux-insight-title { font-size: 18px; }

    /* ── Hero extra small ── */
    .lux-hero-headline { font-size: 36px; }
    .lux-hero-tagline { font-size: 12px; line-height: 1.6; }
    .lux-eyebrow { font-size: 8px; letter-spacing: 0.25em; }

    /* ── Process extra small ── */
    .lux-process-title { font-size: 34px; }
    .lux-process-name { font-size: 20px; }
    .lux-process-desc { font-size: 12px; }

    /* ── Testimonials extra small ── */
    .lux-testimonials-title { font-size: 34px; }
    .lux-testi-quote { font-size: 15px; }

    /* ── Contact extra small ── */
    .lux-contact-title { font-size: 32px; }

    /* ── Work extra small ── */
    .lux-work-title { font-size: 34px; }

    /* ── Featured extra small ── */
    .lux-featured-logo-item { padding: 0 28px; height: 52px; }
    .lux-featured-logo-item img { height: 82px; width: 180px; }

    /* ── Services mobile ── */
    .lux-services { padding: 48px 0; }
    .lux-services-inner { padding: 0 20px; }
    .lux-services-title { font-size: 34px; }
    .lux-service-row { grid-template-columns: 40px 1fr auto; gap: 16px; padding: 20px 0; }
    .lux-service-name { font-size: 20px; }
    .lux-service-num { font-size: 14px; }
    .lux-service-arrow { width: 32px; height: 32px; }

    /* ── About extra small ── */
    .lux-about-title { font-size: 34px; }
  }
  
  /* ── Instagram Feed ── */
  .lux-insta {
    background: var(--white);
    padding: 80px 100px;
    border-top: 0.5px solid var(--border);
  }
  .lux-insta-container {
    max-width: 1520px; /* Wider for desktop impact */
    margin: 0 auto;
    padding: 0 60px;
  }
  .lux-insta-widget-wrapper {
    width: 100%;
    margin-top: 56px;
  }
  @media (max-width: 1200px) {
    .lux-insta-container { max-width: 1320px; padding: 0 48px; }
  }
  @media (max-width: 768px) {
    .lux-insta { padding: 60px 0; }
    .lux-insta-container { padding: 0 20px; }
    .lux-insta-widget-wrapper { margin-top: 32px; }
  }
`;

/* ── Reveal hook ── */
function useReveal() {
  useEffect(() => {
    const els = document.querySelectorAll(".lux-reveal");
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add("visible"); }),
      { threshold: 0.08 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
}

/* ═══════════════════════════════════════════════════════════════════════════
   HERO
═══════════════════════════════════════════════════════════════════════════ */
function Hero() {
  const [videoSrc, setVideoSrc] = useState(
    typeof window !== "undefined" && window.innerWidth <= 768 ? andprvideo : andprdesktopvideo
  );

  useEffect(() => {
    const handleResize = () => {
      setVideoSrc(window.innerWidth <= 768 ? andprvideo : andprdesktopvideo);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section id="hero" className="lux-hero">
      <video className="lux-hero-video" key={videoSrc} src={videoSrc} autoPlay loop muted playsInline preload="none" />
      <div className="lux-hero-overlay" />
      <div className="lux-hero-grain" />

      <div className="lux-hero-content">
        <div className="lux-eyebrow">We Win, When You Win</div>
        <h1 className="lux-hero-headline">
          Your <em>PR</em> &<br />
          <em>Marketing</em> Partner
        </h1>
        <p className="lux-hero-tagline">
          We help ambitious brands land press, grow social, and sharpen
          <br />how they sound.
        </p>
        <a
          href="#contact"
          className="lux-hero-cta"
          onClick={(e) => {
            e.preventDefault();
            document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
          }}
        >
          Start a conversation →
        </a>
      </div>
    </section>
  );
}

/* ═══════════════════════════════════════════════════════════════════════════
   CLIENT LOGOS
═══════════════════════════════════════════════════════════════════════════ */
const clientLogos = [
  { name: "Saachi Rana", src: sr },
  { name: "abrakh", src: abrakh },
  { name: "shashagabal", src: shashagabal },
  { name: "glypticarts", src: glypticarts },
  { name: "miku", src: miku },
  { name: "sha", src: sha },
  { name: "yapidra", src: yapidra },
  { name: "oak", src: oak },
  { name: "maharashtra", src: maharashtra },
  { name: "swati", src: swati },
  { name: "jade", src: jade },
  { name: "noor", src: noor },
  { name: "kesari", src: kesari },
  { name: "sammohan", src: sammohan },
  { name: "Pentagon", src: pentagon },
  { name: "Adyaaye", src: adyaaye },
  { name: "Gavins", src: gavins },
  { name: "Another Day", src: anothe },
  { name: "Bajaj", src: bajaj },
  { name: "Bling", src: bling },
  { name: "Designer Hype", src: designer },
  { name: "Her Stories", src: herstories },
  { name: "Jigar&Nikita", src: jigar },
  { name: "SK Jewellers", src: sk },
  { name: "Dolly Nagpal", src: dollynagpal },
  { name: "Client 8", src: logo8 },
  { name: "Client 66", src: logo66 },
  { name: "Abrakh 2", src: abrakh2 },
  { name: "Miku Brand", src: miku2 },
];

/* ═══════════════════════════════════════════════════════════════════════════
   FEATURED IN
═══════════════════════════════════════════════════════════════════════════ */
function FeaturedIn() {
  const featuredBrands = [
    { name: "Elle", src: fElle },
    { name: "Brides Today", src: fBridesToday },
    { name: "Cosmopolitan", src: fCosmo },
    { name: "Esquire", src: fEsquire },
    { name: "Grazia", src: fGrazia },
    { name: "Lifestyle", src: fLifeStyle },
    { name: "Vogue", src: fVogue }
  ];

  return (
    <section className="lux-featured lux-reveal">
      <div className="lux-featured-inner">
        <p className="lux-featured-label">As featured in</p>
        <div className="lux-featured-marquee-container">
          <div className="lux-featured-marquee">
            {[...featuredBrands, ...featuredBrands].map((brand, i) => (
              <div key={i} className="lux-featured-logo-item">
                <img
                  src={brand.src}
                  alt={brand.name}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

/* ═══════════════════════════════════════════════════════════════════════════
   HOW WE WORK
═══════════════════════════════════════════════════════════════════════════ */
const processStepsData = [
  {
    num: "01",
    title: "Brand Diagnostics",
    desc: "We uncover your audience, category, and luxury positioning. Every strategy starts with a brand audit, market analysis, and the stories that make you desirable."
  },
  {
    num: "02",
    title: "Creative Strategy",
    desc: "From PR concepts to campaign direction, we build integrated creative plans that align media, social, content, and identity for premium impact."
  },
  {
    num: "03",
    title: "Production & Execution",
    desc: "We bring every campaign, shoot, website and PR placement to life with high-touch production and seamless brand consistency."
  },
  {
    num: "04",
    title: "Launch & Momentum",
    desc: "We launch with precision, manage performance, and keep the momentum alive through optimization, PR follow-up and long-term brand growth."
  }
];

function HowWeWork() {
  return (
    <section className="lux-process lux-reveal">
      <div className="lux-process-inner">
        <div className="lux-process-header">
          <div>
            <span className="lux-section-tag">How We Work</span>
            <h2 className="lux-process-title">
              The Anatomy of<br />
              <em>Impact</em>
            </h2>
          </div>
          <p className="lux-process-subtitle">
            A methodical approach to luxury brand building. We combine strategic rigor with creative intuition to deliver work that not only looks beautiful, but moves the needle.
          </p>
        </div>

        <div className="lux-process-grid">
          {processStepsData.map((step, i) => (
            <div key={step.num} className={`lux-process-step lux-reveal lux-reveal-d${(i % 4) + 1}`}>
              <div className="lux-process-num">{step.num}</div>
              <h3 className="lux-process-name">{step.title}</h3>
              <p className="lux-process-desc">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ═══════════════════════════════════════════════════════════════════════════
   ABOUT
═══════════════════════════════════════════════════════════════════════════ */
function About() {
  return (
    <section id="about" className="lux-about">
      <div className="lux-about-inner">
        {/* Left */}
        <div className="lux-reveal">
          <span className="lux-section-tag">About Us</span>
          <h2 className="lux-about-title">
            Strategy<br />
            Meets Craft
          </h2>
        </div>

        {/* Right */}
        <div className="lux-reveal lux-reveal-d2">
          {/* Stats grid */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "40px 32px",
              alignItems: "start",
              marginBottom: "40px",
              paddingBottom: "40px",
              borderBottom: "0.5px solid var(--border)",
            }}
          >
            {[
              { value: "500M+", label: "impressions generated for clients in the last 12 months" },
              { value: "40+", label: "Featured in publications including Vogue India, Forbes and ET" },
              { value: "3x", label: "Average growth in social reach within the first six months" },
              { value: "85%", label: "client retention year-on-year" },
            ].map((stat, i) => (
              <div key={i} style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                <span className="lux-stat-num">{stat.value}</span>
                <span className="lux-stat-lbl">{stat.label}</span>
              </div>
            ))}
          </div>

          <p className="lux-about-desc">
            We have assembled a rare combination of strategy, brand storytelling, design, and digital expertise —
            built to position ambitious brands at the forefront of their industries.
          </p>

          <a href="/about" className="lux-read-btn">
            Discover Our Story
            <svg width="14" height="8" viewBox="0 0 14 8" fill="none">
              <path d="M1 4h12M9 1l3 3-3 3" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </a>
        </div>
      </div>

      {/* Logo marquee */}
      <div className="lux-logos-strip">
        <div style={{ overflow: "hidden" }}>
          <div className="lux-marquee-row fwd">
            {[...clientLogos, ...clientLogos].map((l, i) => (
              <span key={i} className="lux-logo-pill">
                <img
                  src={l.src}
                  alt={l.name || "Client Logo"}
                  style={{ height: "80px", width: "auto", objectFit: "contain", display: "block" }}
                />
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

/* ═══════════════════════════════════════════════════════════════════════════
   RECENT WORK
═══════════════════════════════════════════════════════════════════════════ */
const portfolioItems = [
  { id: 1, image: latestwork1, title: "NOU x Raj Kumar Rao", category: "Celebrity Styling", year: "2026" },
  { id: 2, image: latestwork2, title: "Monture", category: "Creative Shoot", year: "2026" },
  { id: 3, image: latestwork3, title: "Banjara Trail", category: "Fashion", year: "2026" },
  { id: 4, image: AkshayxNOU, title: "Akshay x NOU", category: "Celebrity Styling", year: "2025" },
];

function RecentWork() {
  return (
    <section id="works" className="lux-work lux-reveal">
      <div className="lux-work-inner">
        <div className="lux-work-header">
          <div>
            <span className="lux-section-tag">Selected Work</span>
            <h2 className="lux-work-title">
              Recent <em>Projects</em>
            </h2>
          </div>
          <a href="/work" className="lux-btn-ghost">View All Work</a>
        </div>

        <div className="lux-work-grid">
          {portfolioItems.map((item) => (
            <div key={item.id} className="lux-work-card">
              <img src={item.image} alt={item.title} />
              <div className="lux-work-card-overlay">
                <div className="lux-work-card-info">
                  <h3>{item.title}</h3>
                  <p>{item.category} · {item.year}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ═══════════════════════════════════════════════════════════════════════════
   SERVICES
═══════════════════════════════════════════════════════════════════════════ */
const servicesList = [
  {
    title: "Public Relations",
    desc: "We don't just get you press — we keep you in the conversation.",
    points: [
      "Media Coverage: From press releases to prime coverage, we make sure your brand shows up where it matters.",
      "Influencer Collabs: We handpick creators whose voice and vibe align with your brand.",
      "Celebrity Placements: From red carpets to Instagram, we put your designs on the right faces.",
    ],
  },
  {
    title: "Brand Shoots",
    desc: "We turn ideas into visuals that sell.",
    points: ["Lookbooks & Campaign Shoots", "E-commerce & Catalog Shoots", "On-location & Studio Productions"],
  },
  {
    title: "Brand Development",
    desc: "From identity to sales, we position your brand where it belongs.",
    points: ["Brand Positioning & Messaging", "Visual Identity & Guidelines", "Launch & Go-to-Market Strategy"],
  },
  {
    title: "Podcast Production",
    desc: "Your voice, amplified with intention.",
    points: ["Concept & Format Development", "Recording, Editing & Mixing", "Distribution & Promotion Support"],
  },
  {
    title: "Branding & Packaging",
    desc: "Your brand's first impression — we make sure it's unforgettable.",
    points: ["Logo & Visual System", "Packaging Design for D2C & Retail", "Unboxing & Shelf Presence Strategy"],
  },
  {
    title: "Social Media Marketing",
    desc: "Your brand deserves more than just pretty posts.",
    points: ["Content Strategy & Calendars", "Creative Production & Copywriting", "Community Management & Reporting"],
  },
  {
    title: "Web Development",
    desc: "Where design meets function, and aesthetics meet results.",
    points: ["Design-led Web & Landing Pages", "E-commerce & Shopify Builds", "Performance, SEO & Analytics Setup"],
  },
];

function Services() {
  const [openIndex, setOpenIndex] = useState(null);
  return (
    <section id="services" className="lux-services lux-reveal">
      <div className="lux-services-inner">
        <div className="lux-services-header">
          <div>
            <span className="lux-section-tag">Our Services</span>
            <h2 className="lux-services-title">
              What We <em>Do</em><br />Best
            </h2>
          </div>
          <p className="lux-services-subtitle">
            A curated suite of brand-building capabilities, each designed to create measurable impact and lasting presence in your market.
          </p>
        </div>

        <div className="lux-services-list">
          {servicesList.map((s, i) => {
            const isOpen = openIndex === i;
            return (
              <div
                key={i}
                className={`lux-service-row${isOpen ? " is-open" : ""}`}
                onMouseEnter={() => setOpenIndex(i)}
                onMouseLeave={() => setOpenIndex(null)}
                onClick={() => setOpenIndex((p) => (p === i ? null : i))}
              >
                <span className="lux-service-num">0{i + 1}</span>
                <div className="lux-service-main">
                  <div className="lux-service-name">{s.title}</div>
                  {isOpen && (
                    <div className="lux-service-details">
                      <div className="lux-service-desc">{s.desc}</div>
                      {s.points?.length > 0 && (
                        <ul className="lux-service-points">
                          {s.points.map((p, idx) => <li key={idx}>{p}</li>)}
                        </ul>
                      )}
                    </div>
                  )}
                </div>
                <div className="lux-service-arrow">
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M1 7h12M7 1l6 6-6 6" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

/* ═══════════════════════════════════════════════════════════════════════════
   TESTIMONIALS
═══════════════════════════════════════════════════════════════════════════ */
function Testimonials() {
  const [idx, setIdx] = useState(0);
  const prev = () => setIdx((p) => (p === 0 ? testimonials.length - 1 : p - 1));
  const next = () => setIdx((p) => (p === testimonials.length - 1 ? 0 : p + 1));
  const cur = testimonials[idx];

  return (
    <section className="lux-testimonials lux-reveal">
      <div className="lux-testimonials-inner">
        <div className="lux-testimonials-header">
          <div>
            <span className="lux-section-tag">Client Feedback</span>
            <h2 className="lux-testimonials-title">What They Say</h2>
          </div>
          <div className="lux-testi-nav">
            <button className="lux-nav-btn" onClick={prev} aria-label="Previous"><ChevronLeft size={20} /></button>
            <button className="lux-nav-btn" onClick={next} aria-label="Next"><ChevronRight size={20} /></button>
          </div>
        </div>

        <blockquote className="lux-testi-quote">{cur.quote}</blockquote>

        <div className="lux-testi-author">
          <div>
            <div className="lux-testi-name">{cur.name}</div>
            <div className="lux-testi-role">{cur.role}</div>
          </div>
        </div>

        <div className="lux-testi-progress">
          {testimonials.map((_, i) => (
            <button
              key={i}
              className={`lux-testi-dot${i === idx ? " active" : ""}`}
              onClick={() => setIdx(i)}
              aria-label={`Testimonial ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

/* ═══════════════════════════════════════════════════════════════════════════
   CONTACT
═══════════════════════════════════════════════════════════════════════════ */
function Contact() {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [formData, setFormData] = useState({
    name: "", brand: "", email: "", phone: "", message: "", website: "", ts: Date.now(),
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      // Map 'brand' to 'company' if mock function expects 'company'
      const submissionData = {
        ...formData,
        company: formData.brand
      };
      await submitContactForm(submissionData);
      setShowSuccess(true);
      setFormData({ name: "", brand: "", email: "", phone: "", message: "", website: "", ts: Date.now() });
      setTimeout(() => navigate("/thank-you"), 1500);
    } catch (error) {
      alert(error.message || "Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleWhatsApp = () =>
    window.open(`https://wa.me/${footerData?.whatsappNumber || footerData?.phone}`, "_blank");

  return (
    <section id="contact" className="lux-contact lux-reveal">
      <div className="lux-contact-inner">
        <div className="lux-contact-header">
          <span className="lux-section-tag">Get In Touch</span>
          <h2 className="lux-contact-title">
            Let's Create<br />
            <em>Something Extraordinary</em>
          </h2>
        </div>

        <div className="lux-contact-grid">
          {/* Info */}
          <div>
            {[
              { icon: <MapPin size={16} color="#000000" />, label: "Office Address", val: footerData?.address },
              { icon: <Phone size={16} color="#000000" />, label: "Phone Number", href: `tel:${footerData?.phone}`, val: footerData?.phone },
              { icon: <Mail size={16} color="#000000" />, label: "Email Address", href: `mailto:${footerData?.email}`, val: footerData?.email },
            ].map(({ icon, label, val, href }) => (
              <div key={label} className="lux-contact-info-item">
                <div className="lux-contact-icon">{icon}</div>
                <div>
                  <div className="lux-contact-label">{label}</div>
                  <div className="lux-contact-val">
                    {href ? <a href={href}>{val}</a> : val}
                  </div>
                </div>
              </div>
            ))}
            <button className="lux-whatsapp-cta" onClick={handleWhatsApp}>
              <MessageCircle size={18} color="#000000" />
              Connect on WhatsApp
            </button>
          </div>

          {/* Form */}
          <div>
            {showSuccess && (
              <div className="lux-success">
                Your message has been received. We will be in touch shortly.
              </div>
            )}
            <form onSubmit={handleSubmit}>
              {/* Honeypot field for spam protection */}
              <input
                type="text"
                name="website"
                value={formData.website}
                onChange={handleChange}
                style={{ display: "none" }}
                tabIndex="-1"
                autoComplete="off"
              />

              <div className="lux-form-row">
                <div className="lux-form-field">
                  <label className="lux-form-label" htmlFor="name">Name</label>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Jane Doe"
                    className="lux-form-input"
                  />
                </div>
                {/* <div className="lux-form-field">
                  <label className="lux-form-label" htmlFor="brand">Brand / Company</label>
                  <input
                    id="brand"
                    name="brand"
                    type="text"
                    required
                    value={formData.brand}
                    onChange={handleChange}
                    placeholder="Your Brand Name"
                    className="lux-form-input"
                  />
                </div> */}
              </div>
              <div className="lux-form-field">
                <label className="lux-form-label" htmlFor="email">Email</label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="jane@example.com"
                  className="lux-form-input"
                />
              </div>
              <div className="lux-form-field">
                <label className="lux-form-label" htmlFor="phone">Contact No</label>
                <input
                  id="phone"
                  name="phone"
                  type="tel"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="+91 12345 67890"
                  className="lux-form-input"
                />
              </div>
              {/* <div className="lux-form-field">
                <label className="lux-form-label" htmlFor="message">What you're looking for</label>
                <textarea
                  id="message"
                  name="message"
                  required
                  rows={4}
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="A few sentences about your goals..."
                  className="lux-form-input"
                  style={{ resize: "none", paddingTop: "12px" }}
                />
              </div> */}
              <button type="submit" disabled={isSubmitting} className="lux-submit-btn">
                {isSubmitting ? "Sending…" : <><Send size={14} /> Submit Request</>}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

/* ═══════════════════════════════════════════════════════════════════════════
   INSIGHTS
═══════════════════════════════════════════════════════════════════════════ */
const insightsData = BLOG_POSTS.slice(0, 3).map(post => ({
  ...post,
  slug: `/insights/${post.slug}`
}));


function Insights() {
  return (
    <section className="lux-insights lux-reveal">
      <div className="lux-insights-inner">
        <div className="lux-insights-header">
          <div>
            <span className="lux-section-tag">Insights</span>
            <h2 className="lux-insights-title">
              From the Studio
            </h2>
          </div>
          <Link to="/insights" className="lux-btn-ghost" style={{ marginBottom: "6px" }}>
            View More Insights →
          </Link>
        </div>

        <div className="lux-insights-grid">
          {insightsData.map((item) => (
            <Link key={item.id} to={item.slug} className="lux-insight-card">
              <div className="lux-insight-cat">{item.category}</div>
              <div className="lux-insight-img-placeholder">
                {item.image && (
                  <img
                    src={item.image}
                    alt={item.title}
                    style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                  />
                )}
              </div>
              <h3 className="lux-insight-title">{item.title}</h3>
              <p className="lux-insight-excerpt">{item.excerpt}</p>
              <div className="lux-insight-meta">
                <span className="lux-insight-date">{item.date}</span>
                <span className="lux-insight-read">
                  Read
                  <svg width="12" height="8" viewBox="0 0 14 8" fill="none">
                    <path d="M1 4h12M9 1l3 3-3 3" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
              </div>
            </Link>
          ))}
        </div>


        {/* <div className="lux-insights-footer">
          <a href="/insights" className="lux-btn-ghost">View All Insights →</a>
        </div> */}
      </div>
    </section>
  );
}

/* ═══════════════════════════════════════════════════════════════════════════
   CELEBRITIES
═══════════════════════════════════════════════════════════════════════════ */
const req = require.context("../../asset/images/Celebrity", false, /\.(png|jpe?g|svg|avif)$/i);

const preferredOrder = [
  "akshaykumar",
  "Rubinaa Dilaik",
  "Shahid Kapoor",
  "Elvish x Jannat",
  "Raj Kumar Rao",
  "Krishna Shroff",
  "Siddhant Chaturvedi",
  "Nitibha Paul",
  "Babil Khan",
  "Pragya Jaiswal",
  "Salim Merchant",
  "Vaishali",
  "Randeep Hooda",
  "Khushi Bharwdwaj",
  "Jitendra Kumar",
  "Riya Bedi",
  "Ranvijay Singha",
  "Rubina Dilaik",
  "Saqib Saleem",
  "Taaha Shah",
  "Rithvikk Dhanjani",
  "Manjot",
  "Gurfateh SIngh",
  "Jacky Bhagnani",
  "Darshan Raval",
  "Abhishek Kumar"
];

const celebritiesData = req.keys()
  .sort((a, b) => {
    const nameA = a.split('/').pop().replace(/\.(png|jpe?g|svg|avif)$/i, "");
    const nameB = b.split('/').pop().replace(/\.(png|jpe?g|svg|avif)$/i, "");

    let indexA = preferredOrder.indexOf(nameA);
    let indexB = preferredOrder.indexOf(nameB);

    if (indexA === -1) indexA = 999;
    if (indexB === -1) indexB = 999;

    return indexA - indexB;
  })
  .map((key, index) => {
    const filename = key.split('/').pop().replace(/\.(png|jpe?g|svg|avif)$/i, "");
    const name = filename.replace(/[_-]/g, " ");
    return {
      id: index + 1,
      name: name.charAt(0).toUpperCase() + name.slice(1),
      tag: "Celebrity",
      image: req(key),
    };
  });

function Celebrities() {
  const [current, setCurrent] = useState(0);
  const trackRef = useRef(null);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  // how many cards visible at a time based on screen
  const getVisible = () => {
    if (typeof window === "undefined") return 4;
    if (window.innerWidth <= 480) return 1;
    if (window.innerWidth <= 768) return 2;
    if (window.innerWidth <= 1024) return 3;
    return 4;
  };

  const [visible, setVisible] = useState(getVisible());

  useEffect(() => {
    const onResize = () => setVisible(getVisible());
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const total = celebritiesData.length;
  const maxIndex = Math.max(0, total - visible);

  const prev = () => setCurrent((p) => Math.max(0, p - 1));
  const next = () => setCurrent((p) => Math.min(maxIndex, p + 1));

  // Touch handlers for mobile swipe
  const minSwipeDistance = 50;
  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };
  const onTouchMove = (e) => setTouchEnd(e.targetTouches[0].clientX);
  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;
    if (isLeftSwipe) next();
    if (isRightSwipe) prev();
  };

  useEffect(() => {
    if (!trackRef.current) return;
    const cardW = trackRef.current.children[0]?.offsetWidth || 0;
    const gap = window.innerWidth <= 768 ? 12 : 16;
    trackRef.current.style.transform = `translateX(-${current * (cardW + gap)}px)`;
  }, [current, visible]);

  const dotCount = maxIndex + 1;

  return (
    <section className="lux-celebs lux-reveal">
      <div className="lux-celebs-inner">
        <div className="lux-celebs-header">
          <div>
            {/* <span className="lux-section-tag"></span> */}
            <h2 className="lux-celebs-title">
              Celebrity Collaborations
            </h2>
          </div>
          <div className="lux-celebs-nav">
            <button
              className="lux-celebs-nav-btn"
              onClick={prev}
              disabled={current === 0}
              aria-label="Previous Celebrity"
              style={{ opacity: current === 0 ? 0.3 : 1 }}
            >
              <ChevronLeft size={18} />
            </button>
            <button
              className="lux-celebs-nav-btn"
              onClick={next}
              disabled={current >= maxIndex}
              aria-label="Next Celebrity"
              style={{ opacity: current >= maxIndex ? 0.3 : 1 }}
            >
              <ChevronRight size={18} />
            </button>
          </div>
        </div>

        <div
          className="lux-celebs-track-wrapper"
          onTouchStart={onTouchStart}
          onTouchMove={onTouchMove}
          onTouchEnd={onTouchEnd}
        >
          <div className="lux-celebs-track" ref={trackRef}>
            {celebritiesData.map((celeb, i) => (
              <div
                key={celeb.id}
                className="lux-celeb-card"
              >
                <img src={celeb.image} alt={`${celeb.name} - Celebrity wearing brand attire`} loading="lazy" />
                <div className="lux-celeb-card-overlay">
                </div>
                <div className="lux-celeb-name-strip">
                  <p className="lux-celeb-strip-name">{celeb.name}</p>
                  <p className="lux-celeb-strip-tag">{celeb.tag}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {dotCount > 1 && (
          <div className="lux-celebs-dots">
            {Array.from({ length: dotCount }).map((_, i) => (
              <button
                key={i}
                className={`lux-celebs-dot${i === current ? " active" : ""}`}
                onClick={() => setCurrent(i)}
                aria-label={`Go to ${i + 1}`}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

/* ═══════════════════════════════════════════════════════════════════════════
   INSTAGRAM FEED (BEHOLD)
   ═══════════════════════════════════════════════════════════════════════════ */
function InstagramFeed() {
  useEffect(() => {
    // Only load the script if it hasn't been loaded already
    if (document.querySelector('script[src="https://w.behold.so/widget.js"]')) return;
    const s = document.createElement("script");
    s.type = "module";
    s.src = "https://w.behold.so/widget.js";
    document.head.append(s);
  }, []);

  return (
    <section className="lux-insta lux-reveal">
      <div className="lux-insta-container">
        <div className="lux-celebs-header" style={{ marginBottom: "48px" }}>
          <div>
            <span className="lux-section-tag">Social Presence</span>
            <h2 className="lux-celebs-title">Our <em>Instagram</em></h2>
          </div>
        </div>
        <div className="lux-insta-widget-wrapper">
          <behold-widget feed-id="21j2nAAPkAPpDDt6wtS0"></behold-widget>
        </div>
      </div>
    </section>
  );
}

/* ═══════════════════════════════════════════════════════════════════════════
   CREATIVE BANNER
═══════════════════════════════════════════════════════════════════════════ */
function CreativeBanner() {
  const images = [creative1, creative2, creative3];

  return (
    <section className="lux-creative-banner lux-reveal">
      <div className="lux-creative-banner-header">
        <span className="lux-section-tag">Our Vision</span>
        <h2 className="lux-celebs-title" style={{ marginTop: "16px" }}>Campaign <em>Shoots</em></h2>
      </div>
      <div className="lux-creative-grid">
        {images.map((img, idx) => (
          <div key={idx} className={`lux-creative-img-wrap lux-reveal lux-reveal-d${idx + 1}`}>
            <img
              src={img}
              alt={`Creative Campaign ${idx + 1}`}
              className="lux-creative-img"
            />
          </div>
        ))}
      </div>
    </section>
  );
}

/* ═══════════════════════════════════════════════════════════════════════════
   HOME
═══════════════════════════════════════════════════════════════════════════ */
export default function Home() {
  useReveal();

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "PublicRelationsAgency",
    "name": "AND PR",
    "url": "https://andpragency.com/",
    "logo": "https://andpragency.com/favicon.png",
    "description": "AND PR is a full-stack luxury creative agency specializing in Public Relations, Celebrity Collaborations, Social Media Marketing, and Brand Development.",
    "contactPoint": { "@type": "ContactPoint", "telephone": "+91 7303885011", "contactType": "customer service" },
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Chhatarpur Enclave Phase 2",
      "addressLocality": "New Delhi",
      "addressRegion": "Delhi",
      "postalCode": "110074",
      "addressCountry": "IN"
    },
    "sameAs": [
      "https://www.instagram.com/andpr.agency",
      "https://www.linkedin.com/company/and-pr/"
    ]
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": faqData.map(faq => ({
              "@type": "Question",
              "name": faq.question,
              "acceptedAnswer": {
                "@type": "Answer",
                "text": faq.answer
              }
            }))
          })
        }}
      />
      <style>{GLOBAL_CSS}</style>
      <main>
        <Hero />
        <FeaturedIn />
        <CreativeBanner />

        <HowWeWork />
        {/* <About /> */}
        <Insights />
        <Celebrities />
        <InstagramFeed />
        {/* <RecentWork /> */}
        {/* <Services /> */}
        <Testimonials />
        <Contact />

      </main>
    </>
  );
}